module.exports = __webpack_public_path__ + "static/media/bug.26e4a577.svg";